import qrWechat from '../../assets/images/qr-wechat.jpg';
import qrQq from '../../assets/images/qr-qq.jpg';
import qrWeibo from '../../assets/images/qr-weibo.png';
import qrGithub from '../../assets/images/qr-github.png';

export default [
    { desc: '官方微信公众号', img: qrWechat, icon: 'icon-weixin' },
    { desc: '官方QQ群', img: qrQq, icon: 'icon-iconfonticon6' },
    { desc: '官方微博', img: qrWeibo, icon: 'icon-weibo' },
    { desc: '官方github', img: qrGithub, icon: 'icon-github' }
];
